export const ACCESS_KEY =
  "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ";
export const STYLE_MAP = "mapbox://styles/werneracq/ckwlvecvq38m014nzip0j06jf";
export const STYLE_SATELLITE = "mapbox://styles/mapbox/satellite-streets-v12";
export const DEFAULT_CENTER = [5.556714893765644, 52.191229153189624];
export const MAP_CONTAINER_ID = "map-container";
export const MAP_CONTAINER_SELECTOR = `#${MAP_CONTAINER_ID}`;
